import {API, Setup} from '../../Services';


async function getAwardsApi(merchantUid,page){
    let token =  localStorage.getItem('token');

    return API.get(`/merchants/${merchantUid}/awards`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params : {
            page:page
        }
    });
}

async function getAwardConditionsApi(merchantUid,awardsUid){
    let token =  localStorage.getItem('token');

    return API.get(`/award/${awardsUid}/instruction`,{
        headers: { 'Authorization':  `Bearer ${token}`},
    });
}


// async function getAwardItemsApi(page=1){
//     let token =  localStorage.getItem('token');
//
//     return API.get(`/award/items`,{
//         headers: { 'Authorization':  `Bearer ${token}`},
//         params : {
//             page:page
//         }
//     });
// }

async function getAwardItemsApi(page=1){
    let token =  localStorage.getItem('token');
    let mallId =  localStorage.getItem('mallId');

    return API.get(`/award/${mallId}/items`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params : {
            page:page
        }
    });
}

async function AwardsReceiveApi(merchantUid,awardUid){
    let token =  localStorage.getItem('token');
    return API.post(`/award/${awardUid}/receive`,{},{
        headers: { 'Authorization':  `Bearer ${token}`},
    });
}

export {getAwardsApi,AwardsReceiveApi,getAwardConditionsApi,getAwardItemsApi};


// https://api-test.digimaall.com/v1/awards/m9DtMep6jn/items/?page=1
// https://api-test.digimaall.com/v1/awards/mall_uid/items/?page=1
